import { BASE_URL } from '../endpoints'
import { get, patch } from '../https'

export const addNewPassword = (data: {
  oldPassword: string
  newPassword: string
}): Promise<unknown> => {
  return patch(`${BASE_URL}/settings/reset-password`, data, null)
}

export const getAllNotificationSettings = (): Promise<unknown> => {
  return get(`${BASE_URL}/settings/school-email-notification`)
}

export const UpdateNotificationsSettings = (data: {
  reminderOne: number | undefined
  reminderTwo: number | undefined
  reminderThree: number | undefined
  allowUserInvitationEmail: boolean | undefined
}): Promise<unknown> => {
  return patch(`${BASE_URL}/settings/school-email-notification`, data, null)
}

export const getUserSettings = (): Promise<unknown> => {
  return get(`${BASE_URL}/settings`)
}

export const updateUserSettings = (data: {
  reminderEmail: boolean
}): Promise<unknown> => {
  return patch(`${BASE_URL}/settings`, data, null)
}
